import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { UserStateName } from '@frontend/user/types';
import React from 'react';

import useUserStateSelect from './user-state-select.controller';

const ID = 'user-state-select';

export interface UserStateSelectProps extends Omit<SelectInputV2Props<UserStateName>, 'options'> {
    subset?: string[];
}

export const UserStateSelect = (props: UserStateSelectProps) => {
    const viewProps = useUserStateSelect(props);
    return (
        <SelectInputV2<UserStateName>
            {...props}
            id={ID + props.id}
            label={props.label || 'User state'}
            options={viewProps.options}
        />
    );
};

export default UserStateSelect;
